export const commissionRate = 0.10;

export const calculateContractorAmount = (homeownerAmount: string): string => {
  if (!homeownerAmount) return '';
  const amount = parseFloat(homeownerAmount);
  if (isNaN(amount)) return '';
  const contractorAmount = amount * (1 - commissionRate);
  return contractorAmount.toFixed(2);
};

export const calculateHomeownerAmount = (contractorAmount: string): string => {
  if (!contractorAmount) return '';
  const amount = parseFloat(contractorAmount);
  if (isNaN(amount)) return '';
  const homeownerAmount = amount / (1 - commissionRate);
  return homeownerAmount.toFixed(2);
};

export const calculatePercentDiff = (newAmount: number, baseAmount: number): number => {
  if (baseAmount === 0) return 0;
  return ((newAmount - baseAmount) / baseAmount) * 100;
};